// extracted by mini-css-extract-plugin
export var compact = "_n2-2";
export var phoneFrame = "_n2-0";
export var phoneScreen = "_n2-1";